/*
SH: this file coordinates flow between email collection and plans pages and checkout among other functions on these 2 pages.
Embedded on section page-plans-2

deployment of order workflow(s) (select plan and gather email - go to checkout from either page if other was already selected):
-templates: page.email, page.plans
-snippets: no-meals-checkout.liquid
-sections: page-email, page-plans (existing modified)
-pages: email (with template page.email), subscription (change: add redirect to page, line 1)
-change text-and-image-1 section on home page to save email to session storage email2

For A/B tests:

url?email=false will skip email page when on plans page and email hasn't been entered yet
url?menu=true will show tabs, menu=false will clear it

updated: 08/05/2026
developer: sven.homan@gmail.com

*/

let test = false; //enable/disable console messages and other
let page;
let href = window.location.href;
if(href.includes('pages/email')){
  page = "email"
}else if(href.includes('pages/plans')){
  page = "plans"
}

// customerEmail holds one of three things depending on which path set it: a raw
// address, a base64 address (window.btoa, from theme.liquid and the home page
// form), or the literal "true" flag from the Klaviyo redirect. Returns a usable
// address, or null when all we have is the flag.
function getCustomerEmail() {
  let stored = localStorage.getItem("customerEmail");
  if(!stored) return null;
  if(stored.includes('@')) return stored;
  try {
    let decoded = window.atob(stored);
    if(decoded.includes('@')) return decoded;
  } catch (e) {
    // not base64 - fall through
  }
  return null;
}

// The Klaviyo forms only redirect back with ?email=true; the submitted address
// itself is captured into customerEmail by the klaviyoForms listener in theme.liquid.

//from home page email submission - set in Klaviyo Url
//don't clobber a real address we already captured with the bare flag
if(getUrlParam('email') == 'true' && !getCustomerEmail()){
  localStorage.setItem("customerEmail","true");
}
let email = localStorage.getItem("customerEmail") || null;

//not used
const getCookie = function(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const postData = async (url = "", data = {}) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  return response.json();
};

//not used
const checkEmailExistsOnRecharge = (email) => {
  return;
  console.log('check email',email);
  let app_url = "https://sprinly.herokuapp.com/validateEmail";
  let href = window.location.href;
  if(href.includes('calm-mountain')) {
    app_url = "https://sprinly-staging.herokuapp.com/validateEmail";
  }
  postData(app_url, {email}).then((data) => {
    //if(test) console.log('in check email', email, data);
    console.log(data);
    if (data && data.userFound) {
      //console.log('email exists');
      window.location.href = "/account/login?account=true&email_found=true";
    }else{
      return
    }
  });
}

// Asks the middleware, through the Shopify app proxy, whether this email already
// has a Recharge subscription. Returns 'active', 'cancelled' or 'none'. Fails
// open ('none') when there's no address or the lookup errors or times out, so a
// middleware outage never blocks checkout.
const getSubscriptionStatus = async (email) => {
  if(!email) return 'none';
  let controller = new AbortController();
  let timer = setTimeout(() => controller.abort(), 5000);
  try {
    let response = await fetch('/apps/sprinly/subscription-status?email=' + encodeURIComponent(email), {
      signal: controller.signal
    });
    if(!response.ok) return 'none';
    let data = await response.json();
    return data.status || 'none';
  } catch (e) {
    console.log('subscription status check failed', e);
    return 'none';
  } finally {
    clearTimeout(timer);
  }
}

// Every route to checkout goes through here. Duplicate subscriptions aren't
// allowed, so existing subscribers are sent to the portal message page instead.
const goToCheckout = async (customer_email) => {
  // a logged-in customer checks out under their account email whatever was
  // entered, so that's the address to check
  if(window.loggedInCustomerEmail) customer_email = window.loggedInCustomerEmail;
  let sub_status = await getSubscriptionStatus(customer_email);
  if(sub_status === 'active' || sub_status === 'cancelled'){
    window.location.href = '/pages/subscription-exists?status=' + sub_status;
    return;
  }
  // Shopify sends an empty cart's checkout to the home page - have them pick a plan
  // instead (the address stays stored, so they'll come straight back here)
  let checkout_url = null;
  try {
    let cart = await (await fetch('/cart.js')).json();
    if(!cart.item_count){
      window.location.href = '/pages/plans';
      return;
    }
    // checkout ignores checkout[email] and keeps an email it saw earlier, so put
    // the checked address on the cart itself
    if(customer_email) checkout_url = await setCartBuyerEmail(cart, customer_email);
  } catch (e) {
    console.log('cart check failed', e);
  }
  localStorage.removeItem("customerEmail");
  // prefill the email field on the checkout page when we know it
  window.location.href = checkout_url || (customer_email
    ? '/checkout?checkout%5Bemail%5D=' + encodeURIComponent(customer_email)
    : '/checkout');
}

// Sets the cart's buyer email, which checkout uses for its contact field, and
// returns the cart's checkout url (null on any failure). Uses the Storefront API
// without a token, which acts as the Online Store channel - a token from another
// channel drops the plan lines, since they aren't published there. Only trusts the
// result when the cart kept all its items.
const setCartBuyerEmail = async (cart, email) => {
  try {
    let response = await fetch('/api/2025-01/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: 'mutation($id: ID!, $buyer: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $buyer) { cart { checkoutUrl totalQuantity buyerIdentity { email } } userErrors { message } } }',
        variables: { id: 'gid://shopify/Cart/' + cart.token, buyer: { email: email } }
      })
    });
    let result = ((await response.json()).data || {}).cartBuyerIdentityUpdate || {};
    let updated = result.cart;
    if((result.userErrors || []).length || !updated) return null;
    if(updated.totalQuantity !== cart.item_count || updated.buyerIdentity.email !== email) return null;
    return updated.checkoutUrl;
  } catch (e) {
    console.log('cart buyer email update failed', e);
    return null;
  }
}

// The email page's Klaviyo form redirects to /pages/email?checkout=true once the
// address is submitted (a plan is already in the cart by then). Run the
// subscription check here rather than letting Klaviyo go straight to /checkout,
// which no theme code can see.
if(page === 'email' && getUrlParam('checkout') === 'true'){
  // show only a short message while the check runs - display rather than
  // visibility, because the Klaviyo form sets its own visibility: visible
  let checking_style = document.createElement('style');
  checking_style.textContent =
    'body > * { display: none !important; }' +
    'body::after { content: "One moment…"; display: block; padding-top: 40vh; text-align: center; font-size: 18px; color: #555; }';
  document.head.appendChild(checking_style);
  goToCheckout(getCustomerEmail());
}

//if(test) console.log('page',page);
//console.log('fb', localStorage.getItem("fb_pixel_id"));
let plan_id = localStorage.getItem('mealPlanId') || null;
//let plan_page = "plans";
console.log('load', email, plan_id);

/*************************************************************************** */

//start date on plans page
let start_date;
let selected_delivery_date;

const edit_delivery_date = () => {
    $('#delivery_date').show();
    //selected_delivery_date = $('#delivery_date').val();
    $('#delivery_date').val('0');
    //$('#delivery_date').click();
    $('#delivery_date').attr("size","3");
    $('#close_delivery_date').show();
    $('#edit_delivery_date').hide();
    $('#selected_delivery_date').hide();
}

const close_delivery_date = () => {
    $('#delivery_date').val(selected_delivery_date);
    $('#delivery_date').hide();
    $('#close_delivery_date').hide();
    $('#edit_delivery_date').show();
    $('#selected_delivery_date').show();
}

const change_delivery_date = (value) => {
    selected_delivery_date = value
    let delivery_date = (JSON.parse(value)).date;
    if(test) console.log(value, selected_delivery_date);
    $('#delivery_date').hide();
    $('#selected_delivery_date').show();
    $('#selected_delivery_date').html(delivery_date);
    $('#close_delivery_date').hide();
    $('#edit_delivery_date').show();
}

let spin = 0; //button spinners
document.addEventListener("DOMContentLoaded", async function(event) {
  $('.btn_spin_e').hide();
  $('.btn_spin_0').hide(); //trial card
  $('.btn_spin_1').hide();
  $('.btn_spin_2').hide();
  $('.btn_spin_3').hide();

  if(page === 'plans'){
    //setup delivery dates dropdown selector
    const base_date_str = "November 12, 2021"; // Friday
    const base_week = 287; //goes with base date above
    const day_ms = 1000*60*60*24; //miliseconds in a day

    let today = new Date();
    let base_date = new Date(base_date_str);
    let time_diff = today.getTime() - base_date.getTime();
    let week_diff = Math.floor(time_diff/day_ms/7) + 1;
    let start_week = base_week + week_diff;

    base_date.setDate(base_date.getDate() + (week_diff + 1) * 7 - 4); //monday
    let start_date_1 = String(base_date);
    base_date.setDate(base_date.getDate() + 7);
    let start_date_2 = String(base_date);
    base_date.setDate(base_date.getDate() + 7);
    let start_date_3 = String(base_date);

    let delivery_dates = `
    <option value='{"date":"${start_date_1.substr(0,10)}","week":${start_week}}'>${start_date_1.substr(0,10)} - Almost Sold Out</option>
    <option value='{"date":"${start_date_2.substr(0,10)}","week":${start_week + 1}}'>${start_date_2.substr(0,10)} - Almost Sold Out</option>
    <option value='{"date":"${start_date_3.substr(0,10)}","week":${start_week + 2}}'>${start_date_3.substr(0,10)}</option>`;
    //console.log(delivery_dates);
    $('#delivery_date').append(delivery_dates);
    selected_delivery_date = $("#delivery_date option:eq(1)").val(); //initialize, it's not really always selected but it's what should be used
    
    $('#delivery_date').hide();
    $('#selected_delivery_date').html(start_date_1.substr(0,10));
    $('#close_delivery_date').hide();
    $('#edit_delivery_date').show();
  }
});

const select_plan = async (plan_id, selling_plan_id, plan_title, plan_i) => {
  spin = plan_i;
  localStorage.setItem('mealPlanId', plan_id);
  let start_date = $('#delivery_date option:selected').val();
  start_date = selected_delivery_date;
  sessionStorage.setItem('startDate', start_date);
  sessionStorage.setItem('sellingPlanId', selling_plan_id);
  console.log('selected', plan_title, plan_id, spin, start_date);
  await addToCart(plan_id, selling_plan_id, start_date, true, plan_title);
}

// Returns the order-processing fee product's variant id and its own selling
// plan id for a given meal count, or null if none exists. Fee products are
// unlisted (hidden from search/collections), so they don't appear in
// /products.json; fetch by handle. Results are cached per meal count.
let feeCache = {};
async function findFee(meal_count) {
    if (feeCache.hasOwnProperty(meal_count)) return feeCache[meal_count];
    let handles = [
        `${meal_count}-meals-3-order-processing-fee`
    ];
    for (let i = 0; i < handles.length; i++) {
        try {
            // The .js endpoint returns Content-Type text/javascript, so force
            // dataType 'json' or jQuery would try to execute the body as script.
            let p = await jQuery.ajax({ url: `/products/${handles[i]}.js`, dataType: 'json' });
            let v = p && p.variants && p.variants[0];
            if (v) {
                let alloc = (v.selling_plan_allocations || [])[0];
                let result = { variant_id: v.id, selling_plan_id: alloc ? alloc.selling_plan_id : null };
                feeCache[meal_count] = result;
                return result;
            }
        } catch (e) {
            // 404 for this handle; try the next candidate.
        }
    }
    feeCache[meal_count] = null;
    return null;
}

async function addToCart(variant_id, selling_plan_id, start_date, regular=true, plan_title='') {
    if(regular){
        $('.select-plan-group-item-button').off('click');
        $('.btn_spin_e').show();
        $(`.btn_spin_${spin}`).show();
        localStorage.removeItem('mealPlanId');
        sessionStorage.removeItem('startDate');
    }
    // Start the fee lookup immediately so it runs in parallel with the cart
    // read and cleanup below instead of adding another serial round-trip.
    let meal_count = plan_title ? (plan_title.match(/\d+/) || [])[0] : null;
    let feePromise = meal_count ? findFee(meal_count) : Promise.resolve(null);

    let cart = await jQuery.get('/cart.js');
    //console.log(JSON.parse(cart).items);
    let items = JSON.parse(cart).items;
    console.log(items);

    // Cart rule: when adding a new plan (+ its fee), only gift cards may remain.
    // Remove every non-gift item; the new plan and fee are added fresh below.
    let items_to_remove = items.filter(function(i) {
        return !/gift/i.test(i.title || '');
    });
    if (items_to_remove.length) {
        let updates = {};
        items_to_remove.forEach(function(i) { updates[i.key] = 0; });
        await jQuery.post('/cart/update.js', { updates: updates });
    }

    //may need some other logic here - SH 06/22/24
    if(!items.find(i => i.title.includes('Gift'))){ //there can be also a CC fee or a Trial plan in the cart prior to adding new plan
        //await jQuery.post('/cart/clear.js');
    }

    let first_week = JSON.parse(start_date).date;
    first_week = `Week of ${first_week.substr(4,10)}`;
    let properties = {
        "_start_date": start_date || null,
        "First shipment": first_week,
        /*"discount": localStorage.getItem("discount") || null*/
    };
    // the trial pages each have their own trial product, so match on the title
    // containing "Trial" rather than one exact product title.
    if (plan_title && /trial/i.test(plan_title)) {
        let six_meal_price = window.sixMealPrice || '$109';
        properties["NOTE"] = `It converts to a 6 meal plan at ${six_meal_price} + shipping per week after the first week unless cancelled.`;
    }
    // tag the plan with the brand when it's bought from a sprinly url
    if (/sprinly/i.test(window.location.href)) {
        properties["_brand"] = "sprinly";
    }
    data = {
        "items": [{
        "id": variant_id,
        "quantity": 1,
        "selling_plan": selling_plan_id || null,
        "properties": properties
    }]
  }

  // Automatically add the associated fee product for this x-meals plan,
  // using the fee product's own selling plan id. Add the fee before the plan.
  let fee = await feePromise;
  if (fee) {
      data.items.unshift({ "id": fee.variant_id, "quantity": 1, "selling_plan": fee.selling_plan_id || null });
  }
  //console.log('data', data)

  async function proceed() {
        let email = localStorage.getItem("customerEmail") || null;
        // read before the removeItem below wipes it
        let customer_email = getCustomerEmail();
        if(email){
            if(items.find(i => i.title.includes('Gift'))){
                window.location.href = '/cart';
            }else{
                await goToCheckout(customer_email);
            }
        }else{
            window.location.href = '/pages/email';
        }
  }

  //await jQuery.post('/cart/clear.js');
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() {
        proceed();
    }
  });
}


